var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Contract } from "@ethersproject/contracts";
import { JsonRpcProvider } from "@ethersproject/providers";
import { Multicall } from "ethereum-multicall";
import { namehash } from "@seedao/sns-namehash";
import { keccak_256 } from "@noble/hashes/sha3";
// ABIs
export var PUBLIC_RESOLVER_ABI = [
    "function addr(bytes32) view returns (address)",
    "function name(bytes32) view returns (string)",
];
export var BASE_REGISTRAR_ABI = ["function labelToTokenId(bytes32) view returns (uint256)"];
// sns to address
// parameter 'sns' example: 'abc.seedao' 'sub.abc.seedao'
function resolve(sns, indexerHost, rpc, resolver) {
    return __awaiter(this, void 0, void 0, function () {
        var node, indexerOk, addr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    node = namehash(sns);
                    indexerOk = true;
                    return [4 /*yield*/, fetchGetTimeout("".concat(indexerHost, "/sns/resolver/get_address?node=").concat(node)).catch(function (_) {
                            indexerOk = false;
                        })];
                case 1:
                    addr = _a.sent();
                    if (indexerOk && addr) {
                        return [2 /*return*/, addr];
                    }
                    else {
                        return [2 /*return*/, new Contract(resolver, PUBLIC_RESOLVER_ABI, new JsonRpcProvider(rpc)).addr(node)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
// address to sns
// return addr example: 'abc.seedao' 'sub.abc.seedao'
function name(addr, indexerHost, rpc, resolver) {
    return __awaiter(this, void 0, void 0, function () {
        var rName, node, indexerOk, name;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rName = "".concat(addr.slice(2).toLowerCase(), ".addr.reverse");
                    node = namehash(rName);
                    indexerOk = true;
                    return [4 /*yield*/, fetchGetTimeout("".concat(indexerHost, "/sns/resolver/get_name?node=").concat(node)).catch(function (_) {
                            indexerOk = false;
                        })];
                case 1:
                    name = _a.sent();
                    if (indexerOk && name) {
                        return [2 /*return*/, name];
                    }
                    else {
                        return [2 /*return*/, new Contract(resolver, PUBLIC_RESOLVER_ABI, new JsonRpcProvider(rpc)).name(node)];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
// sns array to address array
// parameter 'snssnsArr' example: ['abc.seedao', 'sub.abc.seedao']
function resolves(snsArr, indexerHost, rpc, resolver) {
    return __awaiter(this, void 0, void 0, function () {
        var nodeArr, indexerOk, names, multicall, calls, r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nodeArr = snsArr.map(function (sns) { return namehash(sns); });
                    indexerOk = true;
                    return [4 /*yield*/, fetchPostTimeout("".concat(indexerHost, "/sns/resolver/get_addresses"), nodeArr).catch(function (_) {
                            indexerOk = false;
                        })];
                case 1:
                    names = _a.sent();
                    if (!(indexerOk && names)) return [3 /*break*/, 2];
                    return [2 /*return*/, names];
                case 2:
                    multicall = new Multicall({
                        nodeUrl: rpc,
                        tryAggregate: true,
                    });
                    calls = nodeArr.map(function (node) {
                        return {
                            reference: "addr",
                            methodName: "addr(bytes32)",
                            methodParameters: [node],
                        };
                    });
                    return [4 /*yield*/, multicall.call({
                            reference: "PublicResolver",
                            contractAddress: resolver,
                            abi: PUBLIC_RESOLVER_ABI,
                            calls: calls,
                        })];
                case 3:
                    r = _a.sent();
                    // return results
                    return [2 /*return*/, r.results["PublicResolver"].callsReturnContext.map(function (ctx) {
                            return ctx.returnValues[0];
                        })];
            }
        });
    });
}
// address array to sns array
// return value example: ['abc.seedao', 'sub.abc.seedao']
function names(addrArr, indexerHost, rpc, resolver) {
    return __awaiter(this, void 0, void 0, function () {
        var nodeArr, indexerOk, addresses, multicall, calls, results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nodeArr = addrArr.map(function (addr) {
                        return namehash("".concat(addr.slice(2).toLowerCase(), ".addr.reverse"));
                    });
                    indexerOk = true;
                    return [4 /*yield*/, fetchPostTimeout("".concat(indexerHost, "/sns/resolver/get_names"), nodeArr).catch(function (e) {
                            indexerOk = false;
                        })];
                case 1:
                    addresses = _a.sent();
                    if (!(indexerOk && addresses)) return [3 /*break*/, 2];
                    return [2 /*return*/, addresses];
                case 2:
                    multicall = new Multicall({
                        nodeUrl: rpc,
                        tryAggregate: true,
                    });
                    calls = nodeArr.map(function (node) {
                        return {
                            reference: "name",
                            methodName: "name(bytes32)",
                            methodParameters: [node],
                        };
                    });
                    return [4 /*yield*/, multicall.call({
                            reference: "PublicResolver",
                            contractAddress: resolver,
                            abi: PUBLIC_RESOLVER_ABI,
                            calls: calls,
                        })];
                case 3:
                    results = _a.sent();
                    // return results
                    return [2 /*return*/, results.results["PublicResolver"].callsReturnContext.map(function (ctx) {
                            return ctx.returnValues[0];
                        })];
            }
        });
    });
}
function tokenId(sns, indexerHost, rpc, baseRegistrar) {
    return __awaiter(this, void 0, void 0, function () {
        var indexerOk, resp, label;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    indexerOk = true;
                    return [4 /*yield*/, fetchGetTimeout("".concat(indexerHost, "/sns/by_name?name=").concat(sns)).catch(function (_) {
                            indexerOk = false;
                        })];
                case 1:
                    resp = _a.sent();
                    if (!(indexerOk && resp)) return [3 /*break*/, 2];
                    return [2 /*return*/, JSON.parse(resp).tokenId];
                case 2:
                    label = keccak_256(sns.replace(".seedao", ""));
                    return [4 /*yield*/, new Contract(baseRegistrar, BASE_REGISTRAR_ABI, new JsonRpcProvider(rpc)).labelToTokenId(label)];
                case 3: // TODO not support subdomain
                return [2 /*return*/, (_a.sent()).toString()];
            }
        });
    });
}
// default timeout is 1000ms
var fetchGetTimeout = function (url, timeout) {
    if (timeout === void 0) { timeout = 1000; }
    return __awaiter(void 0, void 0, void 0, function () {
        var controller, timeoutId, resp, _a, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    controller = new AbortController();
                    timeoutId = setTimeout(function () { return controller.abort(); }, timeout);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(url, { signal: controller.signal })];
                case 2:
                    resp = _b.sent();
                    clearTimeout(timeoutId); // Clear the timeout if the request completes within the specified timeout
                    if (!(resp.status == 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, resp.text()];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = null;
                    _b.label = 5;
                case 5: // Clear the timeout if the request completes within the specified timeout
                return [2 /*return*/, _a];
                case 6:
                    e_1 = _b.sent();
                    // if (e.name === 'AbortError') {
                    //   throw new Error('Request timed out');
                    // }
                    throw e_1;
                case 7: return [2 /*return*/];
            }
        });
    });
};
var fetchPostTimeout = function (url, param, timeout) {
    if (timeout === void 0) { timeout = 1000; }
    return __awaiter(void 0, void 0, void 0, function () {
        var controller, timeoutId, resp, _a, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    controller = new AbortController();
                    timeoutId = setTimeout(function () { return controller.abort(); }, timeout);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(url, {
                            signal: controller.signal,
                            method: "POST",
                            body: JSON.stringify(param),
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    resp = _b.sent();
                    clearTimeout(timeoutId); // Clear the timeout if the request completes within the specified timeout
                    if (!(resp.status == 200)) return [3 /*break*/, 4];
                    return [4 /*yield*/, resp.json()];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = null;
                    _b.label = 5;
                case 5: // Clear the timeout if the request completes within the specified timeout
                return [2 /*return*/, _a];
                case 6:
                    e_2 = _b.sent();
                    // if (e.name === 'AbortError') {
                    //   throw new Error('Request timed out');
                    // }
                    throw e_2;
                case 7: return [2 /*return*/];
            }
        });
    });
};
export { resolve, resolves, name, names, tokenId };
